import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function CodeBlock({ code }: { code: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="code-block">
      <div className="code-header">
        <span>Analyzer Code</span>
        <button onClick={copy}>
          {copied ? t("AI.COPIED") : t("COMMON.COPY")}
        </button>
      </div>

      <pre>
        <code>{code}</code>
      </pre>
    </div>
  );
}
